import { AbstractDateService } from './abstract-date.service';

export abstract class AbstractTimeService<T extends string> extends AbstractDateService<T> {
  abstract midnight(): T;
}
